module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"country":"Country","line1":"Address (line 1)","line2":"Address (line 2)","region":"Region (State)","city":"City","postcode":"ZIP (Postal code)"}}')
  delete Component.options._Ctor
}
